var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppAdobeFonts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1697 0.5H10.4005C4.98383 0.5 0.592773 4.89105 0.592773 10.3077V44.6923C0.592773 50.1089 4.98383 54.5 10.4005 54.5H46.1697C51.5863 54.5 55.9774 50.1089 55.9774 44.6923V10.3077C55.9774 4.89105 51.5863 0.5 46.1697 0.5Z",
    fill: "#000B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.122 23.1123C29.8289 27.4461 28.7408 31.6238 27.4478 35.7128C26.7137 38.0196 25.91 40.2214 24.8965 41.6193C23.778 43.192 21.681 44.695 19.1648 44.695C17.3822 44.695 15.6348 43.8561 15.6348 42.0038C15.6348 40.8504 16.823 39.767 17.7667 39.767C17.9658 39.7592 18.1632 39.8074 18.3362 39.9063C18.5092 40.0052 18.651 40.1507 18.7453 40.3263C19.619 41.899 20.4579 42.8076 20.8423 42.8076C21.2268 42.8076 21.5413 42.2834 22.1703 40.0118L26.7576 23.1152L23.4572 23.1115C23.2124 22.3775 23.5607 21.4987 23.98 21.3239H27.2653C27.8943 19.2968 28.636 17.2246 29.6845 15.3723C31.2572 12.5414 33.7736 10.3047 37.2335 10.3047C39.8547 10.3047 40.9381 11.5629 40.9381 13.1706C40.9032 14.883 39.4005 15.7568 38.7013 15.7568C38.1423 15.7568 37.8627 15.3375 37.6879 14.7433C37.0938 12.5066 36.3249 11.8425 35.8704 11.8425C35.4162 11.8425 34.7171 12.6812 33.9484 14.4286C32.9347 16.6305 32.2529 19.0289 31.6239 21.3354L35.6208 21.3302C35.8654 21.8194 35.6667 22.8323 35.0726 23.1119L31.122 23.1123Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppAdobeFonts);
export default __webpack_public_path__ + "static/media/B_app_AdobeFonts.688d6a860175d7e5a6a86afac7d1f097.svg";
export { ForwardRef as ReactComponent };